import ToggleSwitch from "../../../components/toggle/ToggleSwitch";
import { useEffect, useState } from "react";
import { useSocket } from "../../../contexts/SocketContext";
import { useParams } from "react-router-dom";
import { Loader } from "../../../components/loading/Loader";
import { ArrowUturnLeftIcon } from "@heroicons/react/20/solid";

const BEEP_GROUPS = [
  'Paramétrage des notifications',
  'Paramétrage des alertes'
];

const BEEP_SETTINGS = {
  'email': {
    'label': "Envoi d'un email lors d'une alerte relevée",
    'group': 0
  },
  'chainsaw': {
    'label': 'Utilisation de la tronçonneuse thermique',
    'group': 1
  },
  'collision': {
    'label': 'Risque de collision avec godet',
    'group': 1
  },
  'deadman': {
    'label': "Détection d'homme inerte",
    'group': 1
  },
  'reversing': {
    'label': 'Risque de collision avec engin',
    'group': 1
  },
  'intrusion': {
    'label': 'Intrusion dans la zone de chantier',
    'group': 1
  }
};

export const DevicesSettingsPage = () => {

  const { deviceToken1, deviceToken2 } = useParams();
  const { socket, subscribeToEvent, unsubscribeFromEvent, sendEvent } = useSocket();

  const [enabledBeeps, setEnabledBeeps] = useState(null);

  const changeBeepState = (beepName, enabled) => {
    setEnabledBeeps({...enabledBeeps, [beepName]: enabled});
    sendEvent('current_data', {['enable_' + beepName]: enabled});
  };

  /* First, request all states */
  useEffect(() => {
    if (!socket || !deviceToken1 || !deviceToken2) return;
    sendEvent('current_data', {'request_enabled_beeps': [deviceToken1, deviceToken2]});
  }, [socket, deviceToken1, deviceToken2]);

  useEffect(() => {
    const handleReceivedData = (data) => {
      if (data?.enabled_beeps) {
        setEnabledBeeps(data.enabled_beeps);
      }
    };

    subscribeToEvent('current_data', handleReceivedData);

    return () => {
      unsubscribeFromEvent('current_data', handleReceivedData);
    };
  }, [socket]);

  const openCalibration = () => {
    window.location = '/calibration/' + deviceToken1 + '/' + deviceToken2;
  };

  if (enabledBeeps === null) return <Loader text="Connexion au système en cours..."/>

  const availableBeeps = Object.keys(enabledBeeps);

  return (
    <div className="w-full h-full p-4 bg-gray-100">
      <button className="bg-perception-blue text-white px-4 py-2 mb-4 rounded-md flex items-center" onClick={openCalibration}>
        <ArrowUturnLeftIcon className="size-5 mr-2" /> Retour
      </button>
      {BEEP_GROUPS.map((groupName, groupIndex) => {
        const groupBeeps = availableBeeps.filter((beepName) => BEEP_SETTINGS[beepName]?.group === groupIndex);

        if (groupBeeps.length === 0) return null;

        return (
          <div key={groupIndex} className="bg-white p-4 mb-4 rounded-md">
            <h2 className="text-lg mb-4 font-semibold">{groupName}</h2>
            <div className="grid grid-cols-[80%_auto] gap-4">
              {groupBeeps.map((beepName) => (
                <div key={beepName} className="contents">
                  {BEEP_SETTINGS[beepName].label}
                  <ToggleSwitch enabled={enabledBeeps[beepName]} setEnabled={(enabled) => changeBeepState(beepName, enabled)}/>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};